import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  Heading,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const GameCard = ({ title, description, path }) => {
  const navigate = useNavigate();

  return (
    <Card
      w={{ base: "100%", sm: "280px" }}
      borderRadius="10px"
      border="2px solid #63aab5"
      boxShadow="0 2px 8px rgba(0, 0, 0, 0.08)"
    >
      <CardHeader pb={0}>
        <Heading size="md" color="headline.400" fontStyle="italic">
          {title}
        </Heading>
      </CardHeader>
      <CardBody>
        <Text color="gray.600">{description}</Text>
      </CardBody>
      <CardFooter pt={0}>
        <Button
          onClick={() => navigate(`/practice/${path}`)}
          bg="headline.400"
          color="white"
          _hover={{ bg: "#4a919c" }}
          w="100%"
        >
          Enter Game
        </Button>
      </CardFooter>
    </Card>
  );
};
export default GameCard;
